import {useQuizState} from "../quiz/quizContext";

export const useQuestions = () => {
    const quizState = useQuizState() || {};
    const questions = quizState.quiz?.questions || quizState.questions || [];

    return questions
        .filter(question => question && question.active)
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .map(question => ({
            ...question,
            answers: (question.answers || [])
                .filter(a => a && a.active)
                .sort((a, b) => (a.order || 0) - (b.order || 0))
        }))
}